import React from 'react';
import classnames from 'classnames';
import SectionTitle from 'components/atoms/SectionTitle';
import Button from 'components/atoms/Button';

import { officalLineLink, officalFbLink, telPhone, fillFormLink } from 'routes/Home/config';
import { gtmCustomClick } from 'util/gtmEvent';
import styles from './index.module.css';

interface ContactUsProperty {
	className?: string;
}

const ContactUs: React.FC<ContactUsProperty> = ({ className }) => (
	<div className={classnames(styles.contactUs, className)}>
		<SectionTitle chName="聯絡我們" enName="CONTACT US" />
		<div className={styles.infos}>
			與<span className={styles.strong}>商品、消費者服務</span>相關需求，歡迎透過以下管道與我們聯繫
			<br />
			<a
				className={styles.primary}
				href={officalLineLink}
				target="_blank"
				rel="noreferrer"
				onClick={() => gtmCustomClick(officalLineLink, '愛康官方 LINE 帳號')}
			>
				愛康官方 LINE 帳號
			</a>
			、
			<a
				className={styles.primary}
				href={officalFbLink}
				target="_blank"
				rel="noreferrer"
				onClick={() => gtmCustomClick(officalFbLink, '愛康官方 FB 粉絲專頁')}
			>
				愛康官方 FB 粉絲專頁
			</a>
			，
			<br />
			或撥打免費客服電話{' '}
			<a
				href={`tel:${telPhone}`}
				className={classnames(styles.primary, styles.tel)}
				onClick={() => gtmCustomClick(`tel:${telPhone}`, '0800-889-933')}
			>
				0800-889-933
			</a>
			，將由專人為您服務
			<br />
			<br />
			<span className={styles.strong}>合作洽談</span>請點擊下方按鈕填寫表單
		</div>
		<Button
			pattern="primaryOutline"
			name="填寫表單"
			size="large"
			Icon="arrow"
			handleClick={() => {
				window.open(fillFormLink);
				gtmCustomClick(fillFormLink, '合作洽談-填寫表單');
			}}
		/>
	</div>
);

export default ContactUs;
